export class TopMenuData {
  public id: number
  public name: string
  public key: string
  public value: number
  public color: string
  constructor(
    id: number,
    name: string,
    key: string,
    value: number,
    color: string
  ) {
    this.id = id
    this.name = name
    this.key = key
    this.value = value
    this.color = color
  }
}

export class ChartData {
  public period: string
  public value: number
  constructor(period: string, value: number) {
    this.period = period
    this.value = value
  }
}

export class TopVisitData {
  public id: number
  public title: string
  public total_user_access: string
  public total_visit: string
  public total_assignment: string
  public created_date: string
  public file_type: string
  constructor(
    id: number,
    title: string,
    file_type: string,
    created_date: string,
    total_assignment: string,
    total_user_access: string,
    total_visit: string
  ) {
    this.id = id
    this.title = title
    this.file_type = file_type
    this.created_date = created_date
    this.total_assignment = total_assignment
    this.total_user_access = total_user_access
    this.total_visit = total_visit
  }
}

export class ExportData {
  public link: string
  constructor(link: string) {
    this.link = link
  }
}

export class Export {
  public success: boolean
  public message: string
  public data?: ExportData[]

  constructor(success: boolean, message: string, data?: ExportData[]) {
    this.success = success
    this.message = message
    this.data = data
  }
}

export class NotificationReport {
  public success: boolean
  public message: string
  public topMenu?: TopMenuData[]
  public chart?: ChartData[]
  public topVisit?: TopVisitData[]
  constructor(
    success: boolean,
    message: string,
    topMenu?: TopMenuData[],
    chart?: ChartData[],
    topVisit?: TopVisitData[]
  ) {
    this.success = success
    this.message = message
    this.topMenu = topMenu
    this.chart = chart
    this.topVisit = topVisit
  }
}
